import { parse } from 'date-fns'

export function parseSlugToDate(slug: string) {
  return parse(slug, 'yyyyMMdd', new Date())
}

export function getDateRange(startDateTime, endDateTime) {
  const startDate = new Date(startDateTime)
  const endDate = new Date(endDateTime)
  const startMonth = startDate.toLocaleString('default', { month: 'short' })
  const endMonth = endDate.toLocaleString('default', { month: 'short' })
  const startDay = startDate.getDate()
  const endDay = endDate.getDate()

  let dateRange = `${startMonth} ${startDay}`

  if (startMonth !== endMonth) {
    dateRange += ` - ${endMonth} ${endDay}`
  } else if (startDay !== endDay) {
    dateRange += ` - ${endDay}`
  }

  return dateRange
}
